import { useState, useCallback } from 'react';

const read = (key, fallback) => {
  try {
    const raw = sessionStorage.getItem(key);
    if (raw === null || raw === undefined) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
};

const write = (key, value) => {
  try {
    if (value === undefined || value === null) {
      sessionStorage.removeItem(key);
    } else {
      sessionStorage.setItem(key, JSON.stringify(value));
    }
  } catch {
    // ignore quota/security errors
  }
};

export const useSessionState = (key, initialValue) => {
  const [value, setValue] = useState(() => read(key, initialValue));

  const setAndPersist = useCallback(
    (next) => {
      setValue((prev) => {
        const resolved = typeof next === 'function' ? next(prev) : next;
        write(key, resolved);
        return resolved;
      });
    },
    [key]
  );

  return [value, setAndPersist];
};
